import { ActionTypes } from "../constants";
export default function nsdlPdfAnalyser(state = {}, action) {
  switch (action.type) {
    case ActionTypes.SET_NSDL_PDF_ANALYSER:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
}
